import {CORE_ACTIONS, ToggleErrorModalAction} from './constants/core-actions.constant';
import {IgenomicsAction} from './interfaces/genomics-action.interface';
import {cloneDeep} from "lodash";
import {IEnvironmentDetails} from "@ispm/shared/interfaces/environment-details.interface";


export interface IGeneralErrorState {
    status: boolean;
    title: string;
    content: string;
    btntxt: string;
    callback: any;
}

export interface IcoreState {
    loader: boolean;
    upgradeInjectorStatus: boolean;
    generalError: IGeneralErrorState;
    isEmbedded: boolean;
    environmentDetails: IEnvironmentDetails;
    skipUserInteractionUpdate: boolean;
}

const InitCoreState: IcoreState = {
    loader: false,
    upgradeInjectorStatus: false,
    generalError: {
        status: false,
        title: '',
        content: '',
        btntxt: '',
        callback: null
    },
    isEmbedded: false,
    environmentDetails: undefined,
    skipUserInteractionUpdate: false
};

export function coreReducer(state: IcoreState = InitCoreState, action: IgenomicsAction | ToggleErrorModalAction): IcoreState {
    let newState;
    let payload;
    switch (action.type) {
        case CORE_ACTIONS.TOGGLE_ERROR_MODAL: {
            newState = Object.assign({}, state);
            newState.generalError = {...newState.generalError};
            payload = cloneDeep(action.payload);
            return payload.upsert(newState, 'generalError');
        }

        case CORE_ACTIONS.TOGGLE_UPGRADE_INJECTOR: {
            newState = Object.assign({}, state);
            newState.generalError = {...newState.generalError};
            payload = cloneDeep(action.payload);

            return payload.upsert(newState, 'upgradeInjectorStatus');

        }
        case CORE_ACTIONS.SET_LOADER: {
            newState = Object.assign({}, state);
            newState.generalError = {...newState.generalError};

            newState.loader = action.payload;
            return newState;
        }

        case CORE_ACTIONS.SET_IS_EMBEDDED: {

            newState = Object.assign({}, state);
            newState.generalError = {...newState.generalError};
            newState.isEmbedded = action.payload;
            return newState;
        }

        case CORE_ACTIONS.SET_ENVIRONMENT_DETAILS: {

            newState = Object.assign({}, state);
            newState.environmentDetails = action.payload;
            return newState;
        }
        case CORE_ACTIONS.SKIP_USER_INTERACTION_UPDATE: {
            newState = Object.assign({}, state);
            newState.skipUserInteractionUpdate = action.payload;
            return newState;
        }
        default:
            return state;
    }
}
